<!--
 * @Description: 回弹检测审批
 * @Author: wangwangwang
 * @Date: 2020-12-09 20:04:24
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-25 15:44:54
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <el-form disabled :inline="true" :model="formData" label-width="110px">
                <el-form-item>
                  <span slot="label">是否需要回弹养护</span>
                  <el-input :value="formData.needMaintenance?'是':'否'"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">检测编号</span>
                  <el-input v-model="formData.code"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">订单编号</span>
                  <el-input v-model="formData.logisticsNo"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">工程地址</span>
                  <el-input v-model="formData.engineeringLocation"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">浇筑部位</span>
                  <el-input v-model="formData.pouringPart"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">产品名</span>
                  <el-input v-model="formData.product"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">状态</span>
                  <el-input value="已检测"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">自动检测结果</span>
                  <el-input value="不合格"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" @resetFlowState="resetFlowState"/>
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { SaveSpringBack, makeupdStatus2 } from '@/api/smart/checkout';
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '回弹检测审批',
      billCode: '',
      billDate: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      applyPerson: '',
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {}
    }
  },
  methods: {
    resetFlowState () {
      makeupdStatus2({
        id: this.formData.id,
        detectionStatus: 2,
      });
    },
    handleBusiness () {
      const params = {
        process_success: {
          url: '/icps/system/sign/intelligent/component/save',
          data:this.formData.reboundPart,
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type) {
      if (type === 1) {
        if (this.formData.needMaintenance) {
          SaveSpringBack({id: this.formData.planId})
        }
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType*1 !== 2) { // 提交流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'SpringbackCheck',
        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData(data) {
      this.formData = data;
    },
    initFlowsData2() {
      const { query } = this.$route;
      this.formData = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.applyPerson = query.createUserName;
      this.billDate = query.createTime;
      this.taskStatus = query.taskStatus;
    },
    sendCode(code) {
      this.billCode = code;
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
  },
  mounted() {
    this.initFlowsData2();
    const { query } = this.$route;
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
</style>
